import { Directive, DestroyRef, ElementRef, inject, OnInit, Renderer2 } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ViewportInfo, ViewportSignalService } from 'app/modules/global/services/viewport-signal.service';

@Directive({ selector: '.inner-scroll' })
export class FuseInnerScrollDirective implements OnInit {
  private readonly _elementRef = inject(ElementRef);
  private readonly _renderer = inject(Renderer2);
  private readonly _viewportSignalService = inject(ViewportSignalService);
  private readonly _destroyRef = inject(DestroyRef);

  private _parent: any;
  private _grandParent: any;

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Get the parent
    this._parent = this._renderer.parentNode(this._elementRef.nativeElement);

    // Return, if there is no parent
    if (!this._parent) {
      return;
    }

    // Get the grand parent
    this._grandParent = this._renderer.parentNode(this._parent);

    this._applyForViewport(this._viewportSignalService.viewport());

    // Register to the media query changes
    this._viewportSignalService.onBreakpointChange
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe((viewportInfo: ViewportInfo) => {
        this._applyForViewport(viewportInfo);
      });

    this._destroyRef.onDestroy(() => this._removeClass());
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Private methods
  // -----------------------------------------------------------------------------------------------------

  private _applyForViewport(viewportInfo: ViewportInfo): void {
    if (viewportInfo.alias === 'xs') {
      this._removeClass();
    } else {
      this._addClass();
    }
  }

  /**
   * Add the class name
   *
   * @private
   */
  private _addClass(): void {
    // Add the inner-scroll class
    this._renderer.addClass(this._grandParent, 'inner-scroll');
  }

  /**
   * Remove the class name
   * @private
   */
  private _removeClass(): void {
    if (!this._parent) {
      return;
    }

    // Remove the inner-scroll class
    this._renderer.removeClass(this._grandParent, 'inner-scroll');
  }
}
